<ul class="creator-cards">
	<li
		class="creator-cards__item"
		*ngFor="let card of cards; trackBy: trackByCard"
	>
		<!-- Editor only, and only for a creator Discovery knows: the card is a
		     button that opens the profile, named by its own text so a screen
		     reader still hears the figures. Everywhere else the same card, with
		     nothing to click. No tooltip of its own: the followers inside it
		     carry one, and two at once would cover the card. -->
		<button
			*ngIf="card.openable; else still"
			type="button"
			class="creator-card creator-card--openable"
			(click)="open(card)"
		>
			<ng-container
				*ngTemplateOutlet="face; context: { $implicit: card }"
			></ng-container>
		</button>
		<ng-template #still>
			<div class="creator-card">
				<ng-container
					*ngTemplateOutlet="face; context: { $implicit: card }"
				></ng-container>
			</div>
		</ng-template>
	</li>
</ul>

<!-- Spans only: the card may be a button, which takes no block content. -->
<ng-template #face let-card>
	<span class="creator-card__identity">
		<span class="creator-card__avatar">
			<typography
				*ngIf="card.initials"
				variant="p/xs_semibold"
				class="creator-card__initials"
			>
				{{ card.initials }}
			</typography>
			<img
				*ngIf="card.avatarUrl"
				class="creator-card__picture"
				[src]="card.avatarUrl"
				alt=""
				(error)="hideBrokenImage($event)"
			/>
			<app-social-listening-platform-icon
				class="creator-card__platform"
				[size]="16"
				[socialListeningPlatform]="card.platform"
			></app-social-listening-platform-icon>
		</span>
		<span class="creator-card__who">
			<typography variant="p/base_semibold" class="creator-card__name">
				{{ card.name }}
			</typography>
			<typography variant="p/xs_medium" class="creator-card__handle">
				<ng-container *ngIf="card.handle">
					{{ card.handle }} ·
				</ng-container>
				{{ card.platformLabel }}
			</typography>
		</span>
	</span>

	<span class="creator-card__stats">
		<span class="creator-card__stat">
			<typography variant="p/lg_semibold" class="creator-card__value">
				{{ card.mentions }}
			</typography>
			<typography variant="p/xs_medium" class="creator-card__label">
				{{ mentionsLabel }}
			</typography>
		</span>
		<span
			class="creator-card__stat"
			[matTooltip]="followersHint"
			matTooltipPosition="above"
			matTooltipClass="sentiment-tooltip"
		>
			<typography variant="p/lg_semibold" class="creator-card__value">
				{{ card.followers }}
			</typography>
			<typography variant="p/xs_medium" class="creator-card__label">
				{{ followersLabel }}
			</typography>
		</span>
	</span>

	<span class="creator-card__sentiment">
		<!-- The whole bar is the card's mentions: green the positive share,
		     red the negative, and the track between them the rest. -->
		<span class="creator-card__bar" aria-hidden="true">
			<span
				class="creator-card__bar-positive"
				[style.width.%]="card.positiveShare"
			></span>
			<span
				class="creator-card__bar-negative"
				[style.width.%]="card.negativeShare"
			></span>
		</span>
		<span class="creator-card__legend">
			<span class="creator-card__count creator-card__count--positive">
				<typography variant="p/xs_medium" class="creator-card__label">
					{{ positiveLabel }}
				</typography>
				<typography
					variant="p/xs_semibold"
					class="creator-card__count-value"
				>
					{{ card.positive }}
				</typography>
			</span>
			<span class="creator-card__count creator-card__count--negative">
				<typography variant="p/xs_medium" class="creator-card__label">
					{{ negativeLabel }}
				</typography>
				<typography
					variant="p/xs_semibold"
					class="creator-card__count-value"
				>
					{{ card.negative }}
				</typography>
			</span>
		</span>
	</span>
</ng-template>
